<template>
	<div>
		<div v-if="!noData">
			<div class="row">
				<div class="col-lg-12">
					<p>Total : {{ totalProfiles }}</p>
					<span class="exportProfiles"
						><img
							src="/img/picto_download.png"
							alt="Extract profiles"
							title="Extract profiles"
							width="30"
							height="30"
							border="0"
							@click="exportProfile()"
					/></span>
				</div>
			</div>
			<div class="row dynvibePagination">
				<div class="col-lg-12">
					<div style="float: right; margin-bottom: 10px">
						<pagination
							v-if="requests.page >= 0"
							:page="requests.page"
							:page-max="requests.pageMax"
							@changepage="changePostPage($event)"
						></pagination>
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col-lg-12">
					<table class="table table-striped dynvibeTable">
						<thead style="width: 100%">
							<tr>
								<th class="col-xs-2">Name</th>
								<th class="col-xs-1">Profil</th>
								<th class="col-xs-1">Impact score</th>
								<th class="col-xs-1">Old</th>
								<th class="col-xs-1">Location</th>
								<th class="col-xs-2">Sources</th>
								<th class="col-xs-2">Segments</th>
								<th class="col-xs-1" style="text-align: right">Date modified</th>
								<th class="col-xs-1" style="text-align: right">Actions</th>
							</tr>
						</thead>
						<tbody style="overflow-y: unset">
							<tr
								v-for="(profile, index) in allprofiles"
								class="col-xs-12"
								:key="index"
								:class="[profile.profile_gender == 'male' ? 'dynvibeProfileMale' : 'dynvibeProfileFemale']"
								:idprofile="profile.profile_id"
							>
								<td class="col-xs-2">
									<img
										v-if="profile.source"
										class="dynvibeArrayTopImg"
										:src="profile.source[0].profile_pic"
										width="40"
										height="40"
									/>
									<img v-else class="dynvibeArrayTopImg" src="/img/default_profile_bigger.png" width="40" height="40" />
									<span class="dynvibeProfilesName">{{ profile.profile_name }}</span>
								</td>
								<td class="col-xs-1">
									<fiche :idprofile="profile.profile_id" :middle="true"></fiche>
								</td>
								<td class="col-xs-1">{{ parseInt(profile.post_impact_score) }}</td>
								<td class="col-xs-1">{{ currentYear - profile.profile_yob }} y.o</td>
								<td class="col-xs-1">
									<span
										:class="'flag-icon flag-icon-' + profile.profile_country"
										style="height: 19px; width: 25px; margin-right: 15px; float: left"
									></span>
									{{ profile.profile_location }}
								</td>
								<td class="col-xs-2" v-if="profile.source">
									<div v-for="(hit, index) in profile.source" :key="index">
										<a
											class="dynvibeProfilesLink"
											:href="'https://www.' + hit.media + '.com/' + hit.username"
											target="_blank"
										>
											{{ ucFirst(hit.media) }} ({{ hit.username }})</a
										>
										<br />
									</div>
								</td>
								<td class="col-xs-2" v-if="profile.profile_segments">
									<div v-for="(segment, index) in profile.profile_segments" :key="index">
										<span>{{ segment }} </span>
										<br />
									</div>
								</td>
								<td class="col-xs-1">
									<span v-if="profile.profile_date">{{ dateModif(profile.profile_date) }}</span>
								</td>
								<td class="col-xs-1" align="right">
									<span
										data-action="Edit"
										:data-value="profile.profile_id"
										class="dynvibeTableActions dynvibeTableActionsEdit far fa-edit"
										title="Edit"
										style="display: inline-block"
										@click="editProfile(profile.profile_id)"
									></span>
									<span
										class="dynvibeTableActions dynvibeTableActionsDelete far fa-trash-alt"
										:data-value="profile.profile_id"
										title="Delete"
										@click="deleteProfile(profile.profile_name, profile.profile_id)"
									></span>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
			<div class="row dynvibePagination">
				<div class="col-lg-12">
					<div style="float: right; margin-top: 10px">
						<pagination
							v-if="requests.page >= 0"
							:page="requests.page"
							:page-max="requests.pageMax"
							@changepage="changePostPage($event)"
						></pagination>
					</div>
				</div>
			</div>
		</div>
		<div v-else class="noData">
			<p>No Data to display</p>
		</div>

		<confirm ref="deleteprofile" color="red" title="Delete" @answerconfirm="treatConfirm($event)">
			<template v-slot:confirm-body> Are you sure to delete the profile {{ profileToDelete }} ? </template>
		</confirm>
		<confirm ref="confirm" :color="confirmColor" :title="confirmTitle" :type="confirmType">
			<template v-slot:confirm-body>{{ confirmMessage }}</template>
		</confirm>
	</div>
</template>

<script>
import pagination from "@/components/globalVue/Pagination.vue";
import fiche from "@/components/posts/fiche.vue";
import confirm from "@/components/globalVue/Confirm.vue";

export default {
	name: "profileslist",
	props: {
		search: {
			type: String,
			default: "",
		},
		panel: {
			type: String,
			default: "",
		},
		segment: {
			type: String,
			default: "",
		},
		sort: {
			type: Object,
			default: () => ({
				field: "profile_date",
				order: "desc",
			}),
		},
		size: {
			type: Number,
			default: 20,
		},
		impact_score_min: {
			type: String,
			default: "",
		},
		impact_score_max: {
			type: String,
			default: "",
		},
		is_checked: {
			type: Array,
			default: () => [],
		},
		is_active: {
			type: Array,
			default: () => [],
		},
		no_segment: {
			type: Boolean,
			default: false,
		},
		no_source: {
			type: Boolean,
			default: false,
		},
		private: {
			type: Boolean,
			default: false,
		},
		public: {
			type: Boolean,
			default: false,
		},
		checkbox_all: {
			type: Boolean,
			default: false,
		},
		identical_checkbox_all: {
			// To watch only one data
			type: Number,
			default: 0,
		},
	},
	data() {
		return {
			totalProfiles: 0,
			allprofiles: [],
			currentYear: new Date().getFullYear(),
			idprofile: "",
			profileToDelete: "",
			requests: {
				page: 0,
				pageMax: 0,
			},
			noData: false,
			confirmColor: "",
			confirmTitle: "",
			confirmType: "",
			confirmMessage: "",
		};
	},
	components: {
		pagination: pagination,
		fiche: fiche,
		confirm: confirm,
	},
	mounted: function () {},
	methods: {
		prepareParameters() {
			let p = {};
			p.type = "Profiles";
			p.sort = {
				field: this.$props.sort.field,
				order: this.$props.sort.order,
			};
			if (p.sort.field === "date") {
				// first call
				p.sort.field = "profile_date";
			}
			this.$props.search !== "" ? (p.search = this.$props.search) : false;
			this.$props.panel !== "" ? (p.panel = this.$props.panel) : false;
			this.$props.segment !== "" ? (p.segment = this.$props.segment) : false;
			/*if (this.$props.sort.date.order == "authors") {
                p.orderBy = "profiles";
                delete p.sort;
            } else {
                p.sort = this.$props.sort;
                delete p.orderBy;
            }*/

			p.size = this.$props.size !== "" ? parseInt(this.$props.size) : 20;

			p.impact_score = {
				gt: this.$props.impact_score_min,
				lt: this.$props.impact_score_max,
			};
			this.$props.impact_score_max == "" ? delete p.impact_score.lt : false;
			this.$props.impact_score_min == "" ? delete p.impact_score.gt : false;

			if (this.$props.checkbox_all == true) {
				p.is_checked = ["checked", "unchecked"];
				p.no_segment = true;
			} else {
				p.is_checked = this.$props.is_checked;

				this.$props.no_segment == true ? (p.no_segment = true) : false;

				p.is_checked.length < 1 ? delete p.is_checked : false;
			}
			return p;
		},
		loadComponent(resetPage = true) {
			let p = this.prepareParameters();
			let params = JSON.parse(this.$store.state.parameters);
			p.page = resetPage == true ? 0 : this.requests.page;
			p.age = params["age"];
			p.country = params["country"];
			p.sources = params["sources"];
			p.gender = params["gender"];
			this.getData("listProfiles", p);
		},
		treatResponse(response) {
			this.totalProfiles = response.data.count;
			this.allprofiles = response.data.profiles;
			this.requests.page = parseInt(response.data.page);
			this.requests.pageMax = parseInt(response.data.pageMax);

			this.noData = this.totalProfiles == 0 ? true : false;
		},
		changePostPage(page) {
			this.requests.page = page;
			this.loadComponent(false);
		},
		ucFirst(string) {
			return string.charAt(0).toUpperCase() + string.slice(1);
		},
		dateModif(date) {
			return new Date(date).toISOString().substr(0, 19).replace("T", " ");
		},
		deleteProfile(profile, idprofile) {
			this.profileToDelete = profile;
			this.idprofile = idprofile;
			this.$refs.deleteprofile.open();
		},
		treatConfirm(response) {
			this.$refs.deleteprofile.close();
			if (response === "OK") {
				this.$axios
					.get(this.$backendUrl + "deleteProfile", {
						params: { idprofile: this.idprofile },
						paramsSerializer: function (params) {
							return this.$Qs.stringify(params, {
								arrayFormat: "brackets",
							});
						},
					})
					.then(() => {
						this.confirmSuccessModal("Profile '" + this.profileToDelete + "' has been deleted.");
						setTimeout(function () {
							this.loadComponent();
						}, 750);
					})
					.catch(() => {
						this.confirmErrorModal("Profile '" + this.profileToDelete + "' has not been deleted.");
					});
				this.idprofile = "";
			}
		},
		editProfile(idprofile) {
			this.idprofile = idprofile;
			this.$emit("editprofile", this.idprofile);
		},
		exportProfile() {
			this.confirmLoadingModal("open");

			let p = this.prepareParameters();

			this.$axios.post(this.$backendUrl + "exportProfiles", this.$Qs.stringify(p)).then((response) => {
				this.confirmLoadingModal();

				if (response.data.isOk) {
					let file_path = this.$backendUrl + "/uploads/" + response.data.file;

					let a = document.createElement("A");
					a.href = file_path;
					a.download = file_path.substr(file_path.lastIndexOf("/") + 1);
					document.body.appendChild(a);
					a.click();
					document.body.removeChild(a);
				} else {
					this.confirmErrorModal("Problem getting the file contact IT Team");
				}
			});
		},
	},

	watch: {
		checkbox_all: function () {
			this.loadComponent();
		},
		identical_checkbox_all: function () {
			// To watch only one data
			this.loadComponent();
		},
		"$store.getters.parameters": function () {
			this.loadComponent();
		},
	},
};
</script>

<style scoped></style>
